__turbopack_context__.v({
  "shimmer": "KUkeVq_shimmer",
  "text-bar-sweep": "KUkeVq_text-bar-sweep",
  "tooltip": "KUkeVq_tooltip",
  "tooltip__text": "KUkeVq_tooltip__text",
  "tooltip__text--bottom": "KUkeVq_tooltip__text--bottom",
  "tooltip__text--left": "KUkeVq_tooltip__text--left",
  "tooltip__text--right": "KUkeVq_tooltip__text--right",
  "tooltip__text--top": "KUkeVq_tooltip__text--top",
});
